import { useEffect, useRef, useState } from "react";
import { supabase } from "../supabaseClient";

export function usePresenca({ usuarioId, nome, avatar, desde, entityType, entityId, status }) {
  const [outros, setOutros] = useState([]);
  const canalRef = useRef(null);
  const dadosRef = useRef({});
  dadosRef.current = { nome, avatar, status, desde };

  useEffect(() => {
    if (!usuarioId || !entityId) return;
    const canal = supabase.channel(`presenca:${entityType}:${entityId}`, {
      config: { presence: { key: usuarioId } },
    });
    canalRef.current = canal;

    canal
      .on("presence", { event: "sync" }, () => {
        const estado = canal.presenceState();
        setOutros(
          Object.entries(estado)
            .filter(([id]) => id !== usuarioId)
            .map(([id, v]) => ({ id, ...v[0] }))
        );
      })
      .subscribe(async (s) => {
        if (s === "SUBSCRIBED") await canal.track(dadosRef.current);
      });

    return () => { supabase.removeChannel(canal); canalRef.current = null; };
  }, [usuarioId, entityType, entityId]);

  useEffect(() => {
    canalRef.current?.track({ nome, avatar, status, desde });
  }, [status, nome, avatar, desde]);

  return outros;
}